<div class="thresholds-wrapper">
  <div class="thresholds-header">
    <span class="thresholds-title"
      >{{ '+REMOTE_SERVICE_THRESHOLDS.ADJUST_ANOMALY_FOR' | translate }}
      {{ remoteServiceService.getRemoteServicePrefix(diagnosisGroup) | translate }}</span
    >
    <button
      mat-button
      mat-stroked-button
      gtm="onSelect"
      gtmAction="Open Adjustments"
      gtmCategory="remoteService"
      color="primary"
      (click)="toggleThresholds()"
    >
      <ng-container *ngIf="thresholdsExpanded; then btnExpanded; else btnCollapsed"></ng-container>

      <ng-template #btnExpanded>
        <mat-icon class="close-icon">close</mat-icon>
        {{ '+REMOTE_SERVICE_THRESHOLDS.CLOSE_ADJUSTMENTS' | translate }}
      </ng-template>

      <ng-template #btnCollapsed>
        <mat-icon class="open-icon" svgIcon="adjust"></mat-icon>
        {{ '+REMOTE_SERVICE_THRESHOLDS.OPEN_ADJUSTMENTS' | translate }}
      </ng-template>
    </button>
  </div>
  <div [class.thresholds-loading]="(remoteServiceStore.thresholdsStatus$ | async).loading">
    <div *ngIf="thresholdsExpanded" class="thresholds-content grid">
      <app-remote-service-thresholds-tile
        *ngFor="let threshold of thresholds"
        [threshold]="threshold"
      ></app-remote-service-thresholds-tile>
    </div>
  </div>
</div>
